import * as React from 'react';
import { Button } from "@progress/kendo-react-buttons";
import imgPdf from "../images/icon_pdf.png";
import imgPrint from "../images/icon_print.png";

const CusSavePrint = (props) => {

    return (
        <div  style={{ textAlign: "center", display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap',paddingBottom:'30px' }}>
            <div className="sccbtMid" >
                <Button look="outline" className="btSize2 btLft2" onClick={props.onClick1}>
                    <img className="img-fluid" src={imgPdf} alt="imgPdf"></img>&nbsp;
                    {props.lb1}
                </Button> 
                <Button look="outline" className="btSize2 btRht3" onClick={props.onClick2}>
                    <img className="img-fluid" src={imgPrint} alt="imgPrint"></img>&nbsp;
                    {props.lb2}
                </Button>
            </div>
        </div>

    )
}

export default CusSavePrint;